module.exports = "<ion-icon [class]=\"class ? class : ''\" [color]=\"color ? color : ''\" [slot]=\"slot\" [size]=\"size\" src=\"svg/{{name}}.svg\"></ion-icon>"